<template>
  <div>
    <div 
      v-if="isReportEnabled('salesByClassAndMembershipType')" 
      :class="['reportCard', salesByClassMembership]" 
      @click="getClassMembership()" 
      data-report="classMembership"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.sales-by-classe-membership") }}</div>
    </div>

    <div 
      v-if="isReportEnabled('salesByEventViewTheSalesReport')" 
      :class="['reportCard', salesByEventClass]" 
      @click="prepareReport()" 
      data-report="eventSales"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.sales-by-event") }}</div>
      <div class="cardDesc">{{ $tc("page.report.sales-description") }}</div>
    </div>

    <div 
      v-if="isReportEnabled('salesByEventPricingOptionViewTheSalesReport')"
      :class="['reportCard', salesByPricingOption]" 
      @click="getPricingReport()" 
      data-report="eventPricingSales"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.sales-by-event-price") }}</div>
      <div class="cardDesc">{{ $tc("page.report.sales-description-price") }}</div>
    </div>

    <div 
      v-if="isReportEnabled('eventCouponUsage')" 
      :class="['reportCard', salesByEventCoupon]" 
      @click="getEventCouponReport()" 
      data-report="eventCouponSales"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.event-coupon-usage") }}</div>
    </div>

    <div class="v-spacer"></div>

    <v-text-field v-if="loading" disabled color="success" loading></v-text-field>

    <v-card v-if="displayTable" class="mx-auto" width="101%">
      <v-card-title v-if="report == 'eventSales'">{{ $tc("page.report.sales-by-event") }}</v-card-title>
      <v-card-title v-if="report == 'eventPricingSales'">{{ $tc("page.report.sales-by-event-price") }}</v-card-title>
      <v-card-title v-if="report == 'classMembership'">{{ $tc("page.report.sales-by-classe-membership") }}</v-card-title>
      <v-card-title v-if="report == 'eventCouponUsage'">{{ $tc("page.report.event-coupon-usage") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex" cols="13" sm="6">
              <v-autocomplete 
                v-if="report == 'classMembership'" 
                v-model="eventsSelected" 
                :items="eventItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                :multiple="true" 
                :outlined="true" dense
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="grey--text caption">({{ $t("page.report.filter_selections") }}: {{ eventsSelected.length }} )</span>
                </template>
              </v-autocomplete>
              <v-autocomplete 
                v-if="report == 'eventSales'" 
                v-model="eventSelected"  
                :items="eventItems" 
                item-text="text" 
                item-value="id" 
                dense outlined 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                return-object
              ></v-autocomplete>
              <v-autocomplete
                v-if="report == 'eventPricingSales'"
                v-model="eventPricingSelected"
                :items="eventPricingItems"
                item-text="text"
                item-value="id"
                dense
                outlined
                :label="$tc('page.report.label-event-memberships-select-event')"
                return-object
              ></v-autocomplete>
              <v-autocomplete
                v-if="report == 'eventCouponUsage'"
                v-model="eventCouponSelected"
                :items="eventItems"
                item-text="text"
                item-value="id"
                :label="$tc('page.report.label-event-memberships-select-event')"
                :multiple="true" 
                outlined dense
                return-object
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="grey--text caption">({{ $t("page.report.filter_selections") }}: {{ eventCouponSelected.length }} )</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="13" sm="12">
              <v-card>
                <v-btn v-if="isShowButtons" color="blue-grey" class="ma-1 white--text" @click="dowloadAsPDF()">
                  {{ $tc("page.report.label-pdf-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                </v-btn>
                <v-btn v-if="isShowButtons" color="blue-grey" class="ma-1 white--text" @click="dowloadAsCSV()">
                  {{ $tc("page.report.label-csv-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                </v-btn>
                <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh()">
                  {{ $tc("page.report.label-load-report-btn") }}
                  <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="13" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator v-if="report == 'eventSales'" ref="tabulator" v-model="tabulatorData" :options="tabulatorOptions" class="table-striped table-bordered table-sm" />
                <VueTabulator v-if="report == 'eventPricingSales'" ref="tabulator" v-model="tabulatorPricingData" :options="tabulatorPricingOptions" class="table-striped table-bordered table-sm" />
                <VueTabulator v-if="report == 'classMembership'" ref="tabulator" v-model="tabulatorClassMembership" :options="tabulatorClassMembershipOptions" class="table-striped table-bordered table-sm" />
                <VueTabulator v-if="report == 'eventCouponUsage'" ref="tabulator" v-model="tabulatorEventCoupon" :options="tabulatorEventCouponOptions" class="table-striped table-bordered table-sm" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";

export default {
  mixins: [apiCalls],
  data() {
    return {
      eventSelected: {},
      eventsSelected: [],
      eventPricingSelected: {},
      eventItems: [],
      eventPricingItems: [],
      search: "",
      tabulatorData: [],
      tabulatorPricingData: [],
      tabulatorClassMembership: [],
      FilteredDataEventId: [],
      FilteredSelfRegId: [],
      displayTable: false,
      salesByEventClass: "",
      salesByClassMembership: "",
      salesByPricingOption: "",
      report: "",
      salesByEventCoupon: "",
      tabulatorEventCoupon: [],
      eventCouponSelected: [],
      loadEventsCoupon: false
    };
  },
  computed: {
    ...mapState(["loading"]), 
    ...mapState({
      reportConfig: (state) => state.reports.reportConfig
    }),
    tabulatorOptions() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          //set the initial sort order of the data
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.label-event-sales-first-name"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-last-name"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-number"),
            field: "number",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            //minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-class"),
            field: "class",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("class", "eventSales"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-gross-amount"),
            field: "grossAmount",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            //minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-purchase-created"),
            field: "purchaseCreated",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-paypal-saleId"),
            field: "paypalSaleId",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-paypal-invoice-number"),
            field: "paypalInvoiceNumber",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-address"),
            field: "address",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("city", "eventSales"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("state", "eventSales"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-country"),
            field: "country",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-zip"),
            field: "zip",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 70,
            formatter: "textarea"
          },
        ],
      };
    }, 
    tabulatorPricingOptions() {
      return {
        layout: "fitColumns",//"fitDataFill",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        //resizableColumns: false,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          //set the initial sort order of the data
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        //RaceNumber, Fist Name, Last Name, class, eventRegistrationPrice the user selected, Price of the option
        columns: [
          {
            title: this.$t("page.report.label-event-sales-number"),
            field: "number",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 70,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-first-name"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-last-name"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-class"),
            field: "name",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("name", "eventPricing"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-pricing-option"),
            field: "description",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-status"),
            field: "status",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("status", "eventPricing"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-purchase-created"),
            field: "purchaseCreated",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-paypal-saleId"),
            field: "paypalSaleId", 
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-pricing-price"),
            field: "price",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 60,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-type-membership"), 
            field: "membershipName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-phone"),
            field: "phone",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-email"),
            field: "emailAddress",
            width: 251,
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-birthday"),
            field: "birthday",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-address"),
            field: "address",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("city", "eventPricing"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("state", "eventPricing"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-country"),
            field: "country",
            sorter: "string",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-sales-zip"),
            field: "zip",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 80,
            formatter: "textarea"
          },
        ],
      };
    }, 
    tabulatorClassMembershipOptions() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "active",
        layoutColumnsOnNewData: true,
        initialSort: [
          //set the initial sort order of the data
          {
            column: "ev",
            dir: "asc",
          },
        ],
        //RaceNumber, Fist Name, Last Name, class, eventRegistrationPrice the user selected, Price of the option
        columns: [
          {
            title: this.$t("page.report.label-event-report-eventName"),
            field: "ev",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-className"),
            field: "className",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("className", "classMembership"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-total-registrants"),
            field: "total_registrants",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-yearly-membership"),
            field: "yearly_membership",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-weekend-membership"),
            field: "weekend_membership",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-report-total"),
            field: "total",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 70,
            formatter: "textarea"
          },
        ],
      };
    }, 
    tabulatorEventCouponOptions() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "active",
        layoutColumnsOnNewData: true,
        columns: [
          {
            title: this.$t("page.report.label-firstName"),
            field: "usersName",
            sorter: "string",
            headerFilter:"input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-lastName"),
            field: "usersLastName",
            sorter: "string",
            headerFilter:"input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-couponCode"),
            field: "couponCode",
            sorter: "string",
            headerFilter:"input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-percentage-amount"),
            field: "couponValue",
            sorter: "string",
            formatter: function(cell) {
              const data = cell.getData();
              const type = data.couponTypeName == 'Percentage' ? '%' : '$';
              return `${data.couponValue}${type}`;
            },
            headerFilter:"input",
            headerFilterPlaceholder: " ",
            minWidth: 50
          },
          {
            title: this.$t("page.report.label-transactionDate"),
            field: "created_at",
            sorter: "string",
            headerFilter:"input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-eventName"),
            field: "eventName",
            sorter: "string",
            headerFilter:"input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-totalPaid"),
            field: "totalPaid",
            sorter: "number",
            headerFilter:"input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-discount"),
            field: "totalDiscount",
            sorter: "number",
            headerFilter:"input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          }
        ],
      };
    }, 
    isShowButtons() {
      return (
        (this.report == 'eventSales' && this.tabulatorData.length > 0) || 
        (this.report == 'eventPricingSales' && this.tabulatorPricingData.length > 0) || 
        (this.report == 'classMembership' && this.tabulatorClassMembership.length > 0) || 
        (this.report == 'eventCouponUsage' && this.tabulatorEventCoupon.length > 0)
      );                
    }
  },
  methods: {
    normalizeCaseValue(value) {
      return (value ?? "")
        .toString()
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    },
    getCaseInsensitiveMultiselectFilter(field, source = "eventSales") {
      return {
        headerFilterFunc: (headerValue, rowValue) => {
          const selectedValues = Array.isArray(headerValue) ? headerValue : (headerValue ? [headerValue] : []);
          if (!selectedValues.length) return true;
          const normalizedRowValue = this.normalizeCaseValue(rowValue);
          return selectedValues.map((value) => this.normalizeCaseValue(value)).includes(normalizedRowValue);
        },
        headerFilterParams: {
          values: () => {
            const sourceMap = {
              eventSales: this.tabulatorData,
              eventPricing: this.tabulatorPricingData,
              classMembership: this.tabulatorClassMembership,
            };
            const tableData = sourceMap[source] || [];
            const unique = new Set();
            tableData.forEach((row) => {
              const normalized = this.normalizeCaseValue(row?.[field]);
              if (normalized) unique.add(normalized);
            });
            return Array.from(unique).sort();
          },
          sortValuesList: "asc",
          multiselect: true
        }
      };
    },
    refresh() {
      if (this.report == "classMembership") {
        this.getEventsReport();
      } else if (this.report == "eventSales") {
        this.getReport({
          eventId: this.eventSelected?.id,
        },true);
      } else if(this.report == 'eventPricingSales') {
        this.getPricingReport({
          eventId: this.eventPricingSelected?.id,
        }, true);
      } else {
        this.getEventCouponReport(true);
      }
    },
    async getClassMembership() {
      this.salesByEventClass = "";
      this.salesByPricingOption = "";
      this.salesByEventCoupon = "";

      if(this.salesByClassMembership == "active"){
        this.salesByClassMembership = "";
        this.displayTable = false;
      } else {
        this.salesByClassMembership = "active";
        this.displayTable = true;
      }

      this.report = "classMembership";
      const response = await this.api("get", "/api/v1/promoter/event");

      let arrayItems = [];
      const parent = this;
      response.forEach(function (e) {
        arrayItems.push({
          id: e.id,
          text: parent.$escapeHtml.decode(e.eventName),
        });
      });

      this.eventItems = arrayItems;
    },
    async getEventsReport() {

      const dataEvents = this.eventsSelected.map(eventId => ({
        eventId
      }));

      if(dataEvents.length == 0) {
        this.tabulatorClassMembership = [];
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-events-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }
      
      const data = { events: dataEvents };
      const response = await this.api("post", "/api/v1/promoter/reports/events/salesClassMembership", data);

      this.tabulatorClassMembership = response.map(item => ({
        ...item,
        weekend_membership: item.weekend_membership ?? 0,
        total: `$${item.total}`,
        ev: this.$escapeHtml.decode(item.ev)
      }));
    },
    async prepareReport(filter = null) {
      this.salesByPricingOption = "";
      this.salesByClassMembership = "";
      this.salesByEventCoupon = "";

      if(this.salesByEventClass == "active"){
        this.salesByEventClass = "";
        this.displayTable = false;
      } else {
        this.salesByEventClass = "active";
        this.displayTable = true;
      }

      this.report = "eventSales";

      let data = {};
      data.report = "eventSales";

      if (filter != null) {
        data.filter = filter;
      }

      const response = await this.api("post", "/api/v1/promoter/reports/events/sales", data);

      if (response.filters.length > 0) {
        //select for events
        this.eventItems = response.filters[0].filter.data.map((el) => {
          return {
            ...el,
            text: this.$escapeHtml.decode(el.text)
          };
        });
      }
    },
    async getReport(filter = null, isShowReport = false) {
      this.salesByEventClass = "active";
      this.salesByPricingOption = "";
      this.salesByClassMembership = "";
      this.salesByEventCoupon = "";
      this.report = "eventSales";

      let data = {};
      data.report = "eventSales";

      const isEmptyFilter = !filter || 
                            filter == null || 
                            (typeof filter === 'object' && Object.keys(filter).length === 0) || 
                            (typeof filter === 'object' && Object.values(filter).every(value => value === undefined));
      
      if (!isEmptyFilter) {
        data.filter = filter;
      }

      if(isShowReport && !this.eventSelected?.id) {
        this.displayTable = true;
        this.tabulatorData = [];
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-event-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      const response = await this.api("post", "/api/v1/promoter/reports/events/sales", data);

      if (response.filters.length > 0) {
        //select for events
        this.eventItems = response.filters[0].filter.data.map((el) => {
          return {
            ...el,
            text: this.$escapeHtml.decode(el.text)
          };
        });

        //the table data
        this.tabulatorData = response.results;
      }
      this.displayTable = true;
    },
    async getPricingReport(filter = null, isChange = false) {
      this.salesByEventClass = "";
      this.salesByClassMembership = "";
      this.salesByEventCoupon = "";
      this.report = "eventPricingSales";

      if(!isChange) {
        if(this.salesByPricingOption == "active"){
          this.salesByPricingOption = "";
          this.displayTable = false;
        } else {
          this.salesByPricingOption = "active";
          this.displayTable = true;
        }
      }

      let data = {};
      data.report = "eventPricingSales";

      if(isChange && !this.eventPricingSelected?.id) {
        this.tabulatorPricingData = [];
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-event-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      const isEmptyFilter = !filter || 
                            filter == null || 
                            (typeof filter === 'object' && Object.keys(filter).length === 0) || 
                            (typeof filter === 'object' && Object.values(filter).every(value => value === undefined));
      
      if (!isEmptyFilter) {
        data.filter = filter;
      }

      const response = await this.api("post", "/api/v1/promoter/reports/events/salesprice", data);
      //select for events

      if (response.filters.length > 0) {
        this.eventPricingItems = response.filters[0].filter.data;
        
        //the table data
        if(this.eventPricingSelected.id) {
          this.tabulatorPricingData = response.results;
        }
      }

    },
    async getEventCouponReport(isRefresh = false) {
      this.salesByEventClass = "";
      this.salesByPricingOption = "";
      this.salesByClassMembership = "";

      if(!isRefresh) {
        if(this.salesByEventCoupon == "active"){
          this.salesByEventCoupon = "";
          this.displayTable = false;
        } else {
          this.salesByEventCoupon = "active";
          this.displayTable = true;
        }
      }

      if(!this.loadEventsCoupon) {
        const response = await this.api("get", "/api/v1/promoter/event");
        this.loadEventsCoupon = true;
        this.eventItems = response.map((el) => {
          return {
            id: el.id,
            text: this.$escapeHtml.decode(el.eventName)
          };
        });
      }
      
      this.report = "eventCouponUsage";
      const url = "/api/v1/promoter/reports/events/salesEventCoupon";
      const eventIds = this.eventCouponSelected.map((el) => {
        return el.id
      });

      if(isRefresh && eventIds.length == 0) {
        this.tabulatorEventCoupon = [];
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-events-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      const response = await this.api("post", url, { eventIds });
      this.tabulatorEventCoupon = response.map((el) => {
        return {
          ...el,
          eventName: this.$escapeHtml.decode(el.eventName)
        };
      });
    },
    dowloadAsPDF() {
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      tabulatorInstance.downloadToTab("pdf");
    },
    dowloadAsCSV() {
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      tabulatorInstance.download("csv", "data.csv", {
        delimiter: ",",
      });
    }, 
    isReportEnabled(reportId) {
      return this.reportConfig.sales.reports.find(report => report.name === reportId && report.isEnabled) || false;
    }
  },
  created() {},
  mounted() {},
};
</script>

<style scoped>
.reportCard.active {
  background-color: var(--v-primary-base);
  color: var(--v-lighten-base);
  cursor: auto;
}

.reportCard {
  border: 1px var(--v-primary-darken2) solid;
  padding: 5px 0;
  cursor: pointer;
}

.reportCard .cardImg {
  float: left;
  font-size: 45px;
  width: 50px;
  height: 50px;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard > div > i {
  vertical-align: top;
}

.fal,
.far {
  font-family: "Font Awesome 5 Pro";
}

.fal {
  font-weight: 300;
}

.fa,
.fab,
.fad,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard .cardDesc {
  width: 80%;
}

/*.v-card__title {
  background-color: #ddd;
  color: #333;
}*/

.reportCard {
  text-align: left;
}

.pdl8 {
  padding-left: 8px;
}
</style>
